import {
    SEARCH_REFERRALS,
    SEARCH_REFERRALS_SUCCESS,
    SEARCH_REFERRALS_FAILURE,
    REFRESH_REFERRAL_STATUS,
    REFRESH_REFERRAL_STATUS_SUCCESS,
    REFRESH_REFERRAL_STATUS_FAILURE,
    LIST_REFERRALS,
    LIST_REFERRALS_SUCCESS,
    LIST_REFERRALS_FAILURE,
    FETCH_REFERRAL_DETAILS,
    FETCH_REFERRAL_DETAILS_SUCCESS,
    FETCH_REFERRAL_DETAILS_FAILURE,
    CLOSE_DIALOGS,
    FETCH_REFERRAL_CONTENT,
    FETCH_REFERRAL_CONTENT_SUCCESS,
    FETCH_REFERRAL_CONTENT_FAILURE,
    OPEN_REFERRAL_DETAILS_DIALOG
} from './ReferralListActionTypes';

export const searchReferrals = (personnummer, careUnitId) => ({
    type: SEARCH_REFERRALS,
    personnummer,
    careUnitId
})

export const searchReferralsSucceeded = (referrals) => ({
    type: SEARCH_REFERRALS_SUCCESS,
    referrals
})

export const searchReferralsFailed = (errorMessage) => ({
    type: SEARCH_REFERRALS_FAILURE,
    errorMessage
})

export const refreshReferralStatus = (referralId) => ({
    type: REFRESH_REFERRAL_STATUS,
    referralId
})

export const refreshReferralStatusSucceeded = (referral) => ({
    type: REFRESH_REFERRAL_STATUS_SUCCESS,
    referral
})

export const refreshReferralStatusFailed = (errorMessage) => ({
    type: REFRESH_REFERRAL_STATUS_FAILURE,
    errorMessage
})

export const listReferrals = (careUnitId, opticianId, page = 0) => ({
    type: LIST_REFERRALS,
    careUnitId,
    opticianId,
    page,
})

export const listReferralsSucceeded = (referrals) => ({
    type: LIST_REFERRALS_SUCCESS,
    referrals
})

export const listReferralsFailed = (errorMessage) => ({
    type: LIST_REFERRALS_FAILURE,
    errorMessage
})

export const fetchReferralDetails = (referralId) => ({
    type: FETCH_REFERRAL_DETAILS,
    referralId
})

export const fetchReferralDetailsSucceeded = (details) => ({
    type: FETCH_REFERRAL_DETAILS_SUCCESS,
    details
})

export const fetchReferralDetailsFailed = (errorMessage) => ({
    type: FETCH_REFERRAL_DETAILS_FAILURE,
    errorMessage
})

export const closeDialogs = () => ({
    type: CLOSE_DIALOGS
})

export const fetchReferralContent = (referralId) => ({
    type: FETCH_REFERRAL_CONTENT,
    referralId
})

export const fetchReferralContentSucceeded = (content) => ({
    type: FETCH_REFERRAL_CONTENT_SUCCESS,
    content
})

export const fetchReferralContentFailed = (errorMessage) => ({
    type: FETCH_REFERRAL_CONTENT_FAILURE,
    errorMessage
})

export const openReferralDetailsDialog = (referralId) => ({
    type: OPEN_REFERRAL_DETAILS_DIALOG,
    referralId
})
